
 function DebugLog(message) {
    if (process.env.NODE_ENV === 'development') {
        console.log(message);
      }
  return null; // This component doesn't render anything to the DOM
};

export function printLog(message,info) {
  if (process.env.NODE_ENV === 'development') {
      console.log(message,info);
    }
return null; // This component doesn't render anything to the DOM
};

export default DebugLog;